const HEX_RADIX = 16;
const BYTE_HEX_LENGTH = 2;

const toHex = (bytes: Uint8Array): string => bytes.reduce((result, byte) => result + byte.toString(HEX_RADIX).padStart(BYTE_HEX_LENGTH, "0"), "");

export const getSha256 = async (value: string): Promise<string> => {
	const encoded = new TextEncoder().encode(value);
	const digest = await crypto?.subtle?.digest("SHA-256", encoded);
	return toHex(new Uint8Array(digest));
};
